// extracted by mini-css-extract-plugin
export var base = "_2l-0";
export var updateBanner = "_2l-1";